import React from 'react';
import { Button } from '../../../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../../../components/ui/dialog';
import { Trash2, FileText, X } from 'lucide-react';

interface DocumentDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  documents: any[];
  onDelete: (document: any) => void;
  title?: string;
}

export const DocumentDeleteModal: React.FC<DocumentDeleteModalProps> = ({
  isOpen,
  onClose,
  documents,
  onDelete,
  title = 'Delete Documents'
}) => {
  const handleDelete = (document: any) => {
    onDelete(document);
    onClose();
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[800px] p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
            <Trash2 className="h-5 w-5 text-red-600" />
          </div>
          <DialogTitle className="text-xl font-semibold">
            {title} ({documents.length} files)
          </DialogTitle>
        </div>




        <div className="py-4 max-h-96 overflow-y-auto">
          {documents.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No documents available for deletion
            </div>
          ) : (
            <div className="space-y-3">
              {documents.map((doc, index) => (
                <div
                  key={doc.id || index}
                  className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <FileText className="h-5 w-5 text-gray-500 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">
                        {doc.fileName}
                      </p>
                      <div className="flex items-center gap-4 text-xs text-gray-500">
                        <span>{formatDate(doc.uploadDate)}</span>
                        <span className="capitalize">{doc.type?.toLowerCase().replace('_', ' ')}</span>
                      </div>
                    </div>
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleDelete(doc)}
                    className="flex items-center gap-2 flex-shrink-0"
                  >
                    <Trash2 className="h-4 w-4" />

                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onClose}
            className="flex items-center gap-2"
          >

            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 